var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItasOthericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "71px",
    viewBox: "0 0 69 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustrations / PrivateArea Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FLOW---MOBILE/DESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Denuncia-Sinistro---NaturaSinistro",
    transform: "translate(-563.000000, -336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card/Registrazione/Not-selected-Copy-3",
    transform: "translate(528.000000, 318.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrations-/-PrivateArea-Copy",
    transform: "translate(12.990099, 4.059406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_17668",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_16005",
    transform: "translate(23.587477, 13.906265)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#891124",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2682652,14.684495 L36.0468196,20.7419406 L30.3133147,31.6844752 L23.8645424,44.0567327 L15.9422058,40.3431881 L7.37929487,35.9590297 L12.8570573,25.4963168 L16.2604632,13.7800594 C13.8556711,15.3754059 9.39113646,17.5488119 4.0465226,16.4154257 C-1.74300215,15.1878614 0.380067152,5.26992079 0.380067152,5.26992079 L7.67806715,0 L8.03204735,8.58483168 L15.2245028,5.40875248 L15.2358691,5.43473267 C15.6686018,5.24150495 16.0477503,5.06938614 16.248285,4.95978218 C20.2265028,2.79043564 22.8358889,2.52413861 27.1023246,4.05047525 L27.1023246,4.05047525 L33.2580077,6.09560396 C34.8403642,6.84172277 40.6721068,9.71334653 42.2698889,14.6853069",
    id: "Tracciato_6263"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_16014",
    transform: "translate(56.716802, 18.057414)",
    stroke: "#891124",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_16007"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Tracciato_6265",
    points: "0.587191692 0.349920792 0.573344872 0.392950495 0.547382086 0.461960396"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.545651233,
    y1: 0.470891089,
    x2: 0.319774989,
    y2: 1.1179604,
    id: "Linea_827"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_16020",
    transform: "translate(48.782591, 3.394557)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#891124",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_16015"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.393369,2.75337166 C15.393369,2.75337166 13.6291512,9.70469839 12.6029334,12.6461439 C11.9883423,14.3405579 10.2512571,15.3542561 8.47370563,15.0558073 L8.46802246,15.0558073 C8.46802246,15.0558073 8.46233929,15.0801637 8.44934919,15.126441 L8.44934919,15.1353717 C8.38196306,15.3959855 8.16113137,16.2525202 7.89889375,17.2462627 C7.53791225,18.6442075 6.45382279,19.7404952 5.06000452,20.1170954 C3.66618625,20.4936957 2.17750154,20.092554 1.16160763,19.0666317 C0.14571373,18.0407093 -0.240785479,16.5481561 0.149487809,15.1581043 L2.41788385,6.89964889 C1.8973002,6.88975302 1.41528522,6.62309128 1.13030091,6.1873285 C0.845316594,5.75156571 0.794233162,5.20307925 0.993844244,4.72218354 C1.07076871,4.22765323 1.40588562,3.81182654 1.87277477,3.63157081 C2.33966391,3.45131508 2.86726974,3.53406331 3.25655712,3.84859938 L4.09847791,0.781312253 L4.64893335,0.591332055 C8.35879518,-0.687649859 12.470312,0.141114629 15.3949928,2.75743106 L15.393369,2.75337166 Z",
    id: "Tracciato_6266"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_16021",
    transform: "translate(51.721742, 0.000000)",
    fill: "#891124",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9220991,6.77307705 C13.4022941,7.09159417 12.7864227,7.21557388 12.1838615,7.12299785 C12.1148516,7.11000775 12.0442179,7.09701765 11.9735842,7.07996814 C11.5012549,7.00339476 11.050986,6.82589021 10.6534654,6.5595523 L9.83346543,6.51327507 C9.19551991,6.23903066 8.59920081,5.87664792 8.06194067,5.43672062 C6.727208,4.34392854 5.05798028,3.5775127 4.60007929,3.79103745 C4.1421783,4.0045622 3.70700998,5.53901765 2.11653473,5.65430478 C2.11653473,5.65430478 2.08487137,5.81668101 2.02154463,6.06917606 C1.81532681,6.87618596 1.27380206,8.55109686 0.391287208,8.26125527 C-0.28338606,8.04367111 0.0397426531,6.45076022 0.426198099,5.15986913 C0.393438871,4.65845476 0.403488465,4.15516026 0.456237703,3.65545329 C0.525927781,2.87852788 0.823314905,2.13943756 1.31114859,1.53076022 C1.81263313,0.921741705 2.58163598,0.59841441 3.36764364,0.666106757 C3.8276401,0.796060721 4.29693259,0.890516352 4.77138622,0.94864141 C5.31950063,0.856123553 5.8438136,0.65578081 6.31396047,0.359215667 C7.108364,-0.000586355382 7.99799968,-0.0931677179 8.84946543,0.0953542813 C9.29883681,0.179025352 9.71490979,0.389456309 10.0486139,0.701829529 C10.3828545,1.02169632 10.5296694,1.49064555 10.437505,1.94400775 C10.9960598,1.92004843 11.5553445,1.96945329 12.1010496,2.09095824 C12.6522279,2.21571011 13.1322286,2.55223554 13.437406,3.02786913 C13.7356014,3.51974255 13.6800487,4.14824443 13.3001981,4.58018596 C13.8422393,4.50741546 14.3517194,4.85571197 14.4806733,5.38719587 C14.5837613,5.91885714 14.3650528,6.46149586 13.9220991,6.77307705 L13.9220991,6.77307705 Z",
    id: "Tracciato_6267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9743961,7.08321567 C11.2362949,7.0035946 10.5146376,6.81195573 9.83427731,6.51489884 L10.6542773,6.56117606 C11.0516606,6.82808801 11.5019384,7.00614988 11.9743961,7.08321567 Z",
    id: "Tracciato_6268"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_16023",
    transform: "translate(61.922169, 41.622514)",
    fill: "#891124",
    fillRule: "nonzero",
    stroke: "#891124",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_16022"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.00721744,2.00022593 C2.99260358,2.00915662 2.88787091,1.82648335 2.6767818,1.56505761 C2.12495494,0.880283138 1.37489045,0.382886877 0.529356054,0.141018007 C0.204603579,0.0484635518 -0.00161424281,0.0224833538 0,0.00624573004 C0.0491841966,-0.00208191001 0.0994090999,-0.00208191001 0.148583777,0.00624573004 C0.282670381,0.018449038 0.415651447,0.0407030123 0.546405559,0.0728199875 C1.42221488,0.28391289 2.19554222,0.797068764 2.73036596,1.52202791 C2.81086773,1.63006955 2.88306147,1.74405966 2.94632635,1.86301801 C2.97443257,1.9048735 2.99503724,1.95130268 3.00721744,2.00022593 Z",
    id: "Tracciato_6269"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15974",
    transform: "translate(0.000000, 10.221987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2114617,10.8590027 L38.1379107,10.8590027 C41.8398754,10.8590027 44.8409107,13.8600381 44.8409107,17.5620027 L44.8409107,50.4922651 C44.8409107,54.1942298 41.8398754,57.1952651 38.1379107,57.1952651 L17.2114617,57.1952651 C13.5094971,57.1952651 10.5084617,54.1942298 10.5084617,50.4922651 L10.5084617,17.5620027 C10.5084617,13.8600381 13.5094971,10.8590027 17.2114617,10.8590027 Z",
    id: "Rectangle_6911",
    stroke: "#891124",
    strokeWidth: 1.0000125,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    transform: "translate(27.674686, 34.027134) rotate(-37.156374) translate(-27.674686, -34.027134) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8776424,7.3761079 L48.8036622,7.3761079 C52.5056269,7.3761079 55.5066622,10.3771432 55.5066622,14.0791079 L55.5066622,47.0087911 C55.5066622,50.7107558 52.5056269,53.7117911 48.8036622,53.7117911 L27.8776424,53.7117911 C24.1756778,53.7117911 21.1746424,50.7107558 21.1746424,47.0087911 L21.1746424,14.0791079 C21.1746424,10.3771432 24.1756778,7.3761079 27.8776424,7.3761079 Z",
    id: "Rectangle_6912",
    stroke: "#891124",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    transform: "translate(38.340652, 30.543949) rotate(-20.623000) translate(-38.340652, -30.543949) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1648482,5.43601474 L41.1322541,5.43601474 C44.8413985,5.43601474 47.8482541,8.44287036 47.8482541,12.1520147 L47.8482541,45.1458167 C47.8482541,48.8549611 44.8413985,51.8618167 41.1322541,51.8618167 L20.1648482,51.8618167 C16.4557038,51.8618167 13.4488482,48.8549611 13.4488482,45.1458167 L13.4488482,12.1520147 C13.4488482,8.44287036 16.4557038,5.43601474 20.1648482,5.43601474 Z",
    id: "Rectangle_6912-2",
    stroke: "#891124",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    transform: "translate(30.648551, 28.648916) rotate(-29.120000) translate(-30.648551, -28.648916) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.4356238,
    y1: 32.7845352,
    x2: 38.7088713,
    y2: 22.1472678,
    id: "Line_650",
    stroke: "#891124",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.310495,
    y1: 37.9919411,
    x2: 41.5837426,
    y2: 27.3546738,
    id: "Line_651",
    stroke: "#891124",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.037604,
    y1: 42.9346738,
    x2: 34.6738218,
    y2: 37.6160401,
    id: "Line_652",
    stroke: "#891124",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6762178,14.055248 C26.1634234,14.4793078 24.575395,14.5624942 23.0265743,14.2988124 C22.4237267,15.7497573 21.5064486,17.0488648 20.3408713,18.1024757 C20.3408713,18.1024757 20.6331485,23.4836243 28.2826931,23.8229906 C32.0733663,17.1688124 27.6762178,14.055248 27.6762178,14.055248 Z",
    id: "Path_4659",
    fill: "#891124",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_16026",
    transform: "translate(39.530499, 28.424325)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_16024",
    transform: "translate(0.000000, 17.234319)",
    fill: "#891124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.32502574,6.90940376 L10.489501,5.86694832 L9.30090693,2.35069089 L6.68664951,1.74502752 C6.44308515,1.69063148 6.17191683,1.62568099 5.86908515,1.54124535 C5.51560648,1.44192694 5.18113657,1.2844325 4.87940198,1.07522554 C4.4954158,0.830344246 4.14637958,0.534564727 3.84181782,0.195958216 C3.59825347,-0.140972477 3.06971881,-0.0151308925 3.07134257,0.358334454 C3.39469479,1.23640186 4.05351131,1.95011976 4.90294654,2.34257208 C6.07530297,3.00912653 4.0025703,3.33225525 3.24995644,3.46296812 C2.49734257,3.59368099 0.189976238,4.10841366 0.0527683175,4.37065129 C-0.147766336,4.75467109 0.236253466,5.04857208 0.98399604,4.89999782 C1.73173861,4.75142356 4.01150099,4.46401762 4.06914456,4.86265129 L4.06183762,4.87320574 C3.68573532,5.46090742 3.72556258,6.22284867 4.16088713,6.76813643 C4.57981782,7.29423544 5.20983762,7.95429485 5.67423366,7.85443346 C6.57757944,7.5978339 7.46308499,7.28214371 8.32502574,6.90940376 L8.32502574,6.90940376 Z",
    id: "Tracciato_6270"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_16025",
    transform: "translate(8.193501, 0.000000)",
    fill: "#FFFFFF",
    stroke: "#891124",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,17.9547525 L2.02970297,24.8127129 L17.780198,20.0266733 C19.4057069,19.5327994 20.7635243,18.4045584 21.5467247,16.8969817 C22.3299251,15.3894049 22.4723845,13.629774 21.941901,12.0158416 L18.0805941,0 L9.69467327,2.08166337 L14.2972277,13.1963168 L0,17.9547525 Z",
    id: "Tracciato_6271"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Tracciato_6272",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "58.7607129 35.4811959 61.4009505 30.682978 65.8581782 29.9092553 65.2541386 28.1133741 56.3380594 27.2519681 54.4447525 30.682978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.953361,53.2710181 L36.265163,53.2710181 C37.3809805,53.2710181 38.2855293,54.1755669 38.2855293,55.2913844 C38.2855293,56.407202 37.3809805,57.3117508 36.265163,57.3117508 L28.953361,57.3117508 C27.8375435,57.3117508 26.9329947,56.407202 26.9329947,55.2913844 C26.9329947,54.1755669 27.8375435,53.2710181 28.953361,53.2710181 Z",
    id: "Rettangolo_17961",
    stroke: "#8B1125",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(32.609262, 55.291384) rotate(-30.000000) translate(-32.609262, -55.291384) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0740792,52.7490969 C35.0740792,52.7490969 37.1906535,55.6946018 35.0018218,55.2943444 C32.8129901,54.894087 32.2333069,53.0706018 31.4149307,55.1676909 C30.5965545,57.26478 29.0604752,56.806879 28.645604,56.7467998",
    id: "Path_6264",
    stroke: "#891124",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItasOthericon);
export default __webpack_public_path__ + "static/media/itas-other.icon.ae7dc4a2c517cf5926404546efdccc3c.svg";
export { ForwardRef as ReactComponent };